import gql from 'graphql-tag';

import clientWorkspaceLeadFragment from './client-workspace-lead-fragment';

const createOneClientWorkspaceLeadMutation = gql`
  ${clientWorkspaceLeadFragment}
  mutation createOneClientWorkspaceLeadMutation($record: CreateOneClientWorkspaceLeadInput!) {
    createOneClientWorkspaceLeadMutation(record: $record) { record { ...ClientWorkspaceLeadFragment } }
  }
`;
export default createOneClientWorkspaceLeadMutation;
